import FilterForm from '../../../components/forms/FilterForm';
import { CrudFilters, HttpError } from '@refinedev/core';
import { Form, Input, Table } from 'antd';
import { ILogDeletedUser } from 'interfaces/log_deleted_users';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { TextField, useTable } from '@refinedev/antd';
import { formatDate } from 'services/date';

interface IFilter {
  email: string;
  deleted_at: string;
}

export const LogDeletedUserList = () => {
  const { tableProps, searchFormProps } = useTable<
    ILogDeletedUser,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { email } = params;

      filters.push({
        field: 'filter[email]',
        operator: 'eq',
        value: email
      });

      return filters;
    }
  });

  return (
    <ListLayout title="Alunos excluídos" canCreate={false}>
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="email">
          <Input placeholder="E-mail do aluno" className="lg:min-w-[300px]" />
        </Form.Item>
      </FilterForm>
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="email"
          key="email"
          title="E-mail"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="text"
          key="text"
          title="Motivo"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="deleted_at"
          key="deleted_at"
          title="Data de exclusão"
          render={value => <TextField value={formatDate(value)} />}
        />
      </Table>
    </ListLayout>
  );
};
